import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import leftArrow from "../assets/icons/left-arrow.svg";
import RegularGameIcon from "../assets/images/regular-game-icon.svg";
import StandardGameIcon from "../assets/images/standard-game-icon.svg";
import PremiumGameIcon from "../assets/images/premium-game-icon.svg";
import JackpotImage from "../assets/images/ton-image.svg";
import MegaJackpotImage from "../assets/images/mega-jackpot-image.svg";
import { AllTicketsCount } from "../constants/const";
import { Progress, Spin } from "antd";
import { getCycleSold, getLevelPriceNano } from "../blockchain/lotteryClient";
import { getMegaJackpotInfo } from "../blockchain/lotteryClient";

const GamePage = () => {
    const [accessibleTicketsCount, setAccessibleTicketsCount] = useState<number>(0);
    const [ticketPrice, setTicketPrice] = useState<number | null>(null);
    const [gameInfo, setGameInfo] = useState({ name: "", icon: "" });
    const [loading, setLoading] = useState<boolean>(false);
    const [megaActive, setMegaActive] = useState(false);
    const [megaProgressPercent, setMegaProgressPercent] = useState(0);
    const [megaTickets, setMegaTickets] = useState<{ sold: number; total: number } | null>(null);


    const { gameName }: any = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;

        async function load() {
            setLoading(true);

            localStorage.setItem("gameName", gameName);

            let level: number;

            switch (gameName) {
                case "regular-game":
                    level = 0;
                    setGameInfo({ name: "Регулярная игра", icon: RegularGameIcon });
                    break;

                case "standard-game":
                    level = 1;
                    setGameInfo({ name: "Стандартная игра", icon: StandardGameIcon });
                    break;

                case "premium-game":
                    level = 2;
                    setGameInfo({ name: "Премиум игра", icon: PremiumGameIcon });
                    break;

                default:
                    setLoading(false);
                    return;
            }

            // ✅ 1. ЦЕНА
            try {
                const priceNano = await getLevelPriceNano(level);
                if (!cancelled) {
                    setTicketPrice(Number(priceNano) / 1e9);
                }
            } catch (err) {
                console.error("Error loading ticket price:", err);
                if (!cancelled) setTicketPrice(null);
            }
            try {
                const sold = await getCycleSold(level);
                if (!cancelled) {
                    setAccessibleTicketsCount(AllTicketsCount - sold);
                }
            } catch (err) {
                console.error("Error loading sold tickets:", err);
            }

            if (!cancelled) {
                setLoading(false);
            }
        }

        load();

        return () => {
            cancelled = true;
        };
    }, [gameName]);



    useEffect(() => {
        let cancelled = false;

        async function loadMega() {
            const mega = await getMegaJackpotInfo();
            if (!mega) return;

            if (!mega.isActive) {
                // 🔥 сбор к 25 000
                const percent = Math.min(
                    100,
                    Math.floor(
                        (Number(mega.balance) / Number(mega.threshold)) * 100
                    )
                );

                setMegaActive(false);
                setMegaProgressPercent(percent);
                setMegaTickets(null);
            } else {
                // 🎟️ MEGA активен → билеты
                setMegaActive(true);
                setMegaProgressPercent(100);
                setMegaTickets({
                    sold: mega.ticketsSold,
                    total: mega.ticketsRequired,
                });
            }
        }



        loadMega();

        return () => {
            cancelled = true;
        };
    }, []);


    const handleJackpotPage = () => navigate("/jackpot");
    const soldTickets = AllTicketsCount - accessibleTicketsCount;

    const progressPercent =
        soldTickets === 0
            ? 0
            : Math.max(1, Math.floor((soldTickets / AllTicketsCount) * 100));
    return (
        <>
            {loading ? (
                <Spin fullscreen={true} size="large" />
            ) : (
                <div className="game-page">
                    <div className="game-page_title">
                        <img
                            className="game-page_title_left-arrow"
                            src={leftArrow}
                            alt="icon"
                            width={32}
                            height={32}
                            onClick={() => navigate("/games")}
                        />
                        <span>{gameInfo.name}</span>
                    </div>

                    <div className="game-page_game-info">
                        <div className="game-page_game-info__price">
                            Стоимость билета: {ticketPrice !== null ? `${ticketPrice} GRAM` : "Загрузка..."}
                        </div>

                        <img src={gameInfo.icon} alt="icon" height={300} />
                    </div>

                    <div className="jackpot-card" onClick={handleJackpotPage}>
                        <div className="jackpot-card_header">
                            <div className="jackpot-card_header__info">
                                <span className="jackpot-card_header__info___title">
                                    Джекпот
                                </span>
                                <span className="jackpot-card_header__info___subtitle">
                                    Доступные билеты:
                                </span>
                                <div className="jackpot-card_header__info___ticket-count">
                                    <span className="jackpot-card_header__info___ticket-count____accessible-count">
                                        {accessibleTicketsCount}
                                    </span>
                                    <span className="jackpot-card_header__info___ticket-count____total-count">
                                        / {AllTicketsCount}
                                    </span>
                                </div>
                                <div className="charts">
                                    <Progress
                                        percent={progressPercent}
                                        strokeColor="#FFD700"
                                        percentPosition={{ align: "end", type: "inner" }}
                                        size={["100%", 16]}
                                    />

                                </div>
                            </div>
                            <img src={JackpotImage} alt="icon" />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default GamePage;
